import { render } from "./ChannelSelect.vue?vue&type=template&id=5c828fa4"
import script from "./ChannelSelect.vue?vue&type=script&lang=js"
export * from "./ChannelSelect.vue?vue&type=script&lang=js"

import "./ChannelSelect.vue?vue&type=style&index=0&id=5c828fa4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__